import { useState } from "react";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto max-w-4xl px-4 md:px-10 py-16 md:py-24">
        <Reveal>
          <SectionHeading eyebrow="常见问题" title="关于阅读与下载" align="center" />
        </Reveal>

        <div className="mt-10 divide-y divide-background-200/80 rounded-lg border border-background-200/80 bg-background-50">
          {faqs.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={item.q}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="flex w-full items-center justify-between gap-4 px-5 md:px-6 py-5 text-left cursor-pointer"
                >
                  <span className="font-heading text-base md:text-lg text-foreground-900">
                    {item.q}
                  </span>
                  <i
                    className={`shrink-0 text-xl transition-transform duration-300 ${
                      isOpen ? "ri-subtract-line text-primary-600" : "ri-add-line text-foreground-400"
                    }`}
                  />
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    isOpen ? "max-h-64 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <p className="px-5 md:px-6 pb-5 text-sm leading-relaxed text-foreground-600">
                    {item.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}